import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_intercompany_auto_purchase_stock_location_config_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    src_location_guid:fromDatatype.GuidDataFieldInterface;
    src_location_code:fromDatatype.VarcharDatatypeInterface;
    target_location_guid:fromDatatype.GuidDataFieldInterface;
    target_location_code:fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_intercompany_auto_purchase_stock_location_config_RowClass implements bl_fi_intercompany_auto_purchase_stock_location_config_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    src_location_guid:fromDatatype.GuidDataFieldInterface;
    src_location_code:fromDatatype.VarcharDatatypeInterface;
    target_location_guid:fromDatatype.GuidDataFieldInterface;
    target_location_code:fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}